import React, { FunctionComponent, useCallback, useLayoutEffect, useRef, useState } from 'react';

import cn from 'classnames';

import Button from '../../../../shared/components/button';
import SvgImage from '../../../../shared/components/svg-image';
import { countMetrika } from '../../../../shared/helpers/metrika';
import audioUrl from './background-audio.mp3';
import classes from './index.css';

const audioOnIcon = <SvgImage imageName="audioOn" />;
const audioOffIcon = <SvgImage imageName="audioOff" />;

interface BackgroundAudioButtonProps {
    autoplay: boolean;
    className?: string;
}

const BackgroundAudioButton: FunctionComponent<BackgroundAudioButtonProps> = ({ className, autoplay }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef<HTMLAudioElement>(null);

    const onButtonClick = useCallback(() => {
        if (audioRef.current?.paused === false) {
            audioRef.current?.pause();
            countMetrika('stream_viewers_screen', 'music_off');
        } else if (audioRef.current?.paused === true) {
            audioRef.current?.play();
            countMetrika('stream_viewers_screen', 'music_on');
        }
    }, []);

    useLayoutEffect(() => {
        if (audioRef.current) {
            // При открытии страницы может не прийти (или мы не успеваем подписаться) первое событие playing.
            setIsPlaying(audioRef.current.paused === false);
        }
    }, []);

    const onPlay = useCallback(() => {
        setIsPlaying(true);
    }, []);

    const onPause = useCallback(() => {
        setIsPlaying(false);
    }, []);

    return (
        <>
            <Button
                className={cn(classes.BackgroundAudioButton, className)}
                pin="round-round"
                size="lg"
                view="neutral"
                onClick={onButtonClick}
                icon={isPlaying ? audioOnIcon : audioOffIcon}
            />
            <audio src={audioUrl} ref={audioRef} onPlay={onPlay} onPause={onPause} autoPlay={autoplay} loop />
        </>
    );
};

export default BackgroundAudioButton;
